export type FlagReason = 'lost' | 'stolen' | 'other';

export interface FlaggedSerial {
  id: number;
  serial: string;
  reason: FlagReason;
  reasonLabel: string;
  notes: string;
  replacement_serial: string;
  original_order_number: string;
  reported_at: string | null;
  is_active: boolean;
  createdBy: string | null;
  hitCount: number;
  created_at: string;
  updated_at: string;
}

export interface FlaggedSerialHit {
  id: number;
  serial: string;
  reason: FlagReason;
  reasonLabel: string;
  replacementSerial: string;
  /** Same person is linked to the replacement unit too -- the triage signal. */
  alsoHasReplacement: boolean;
  detectedAt: string;
  isResolved: boolean;
  cushionName: string | null;
  user: { id: number; email: string; name: string } | null;
  notes: string;
}

export interface FlagStats {
  total: number;
  unresolved: number;
  also_has_replacement: number;
  flagged_serials: number;
}

export const REASON_COLORS: Record<FlagReason, string> = {
  lost: 'orange',
  stolen: 'red',
  other: 'default',
};
